import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";

const DEFAULT_STAGE_SCROLL_OFFSET = 125;
const DEFAULT_SCROLL_PAGE_SIZE = 250;

export function transformProcessElement(element: HTMLElement) {
  $(element).prepend(
    $('<div class="scroll-button scroll-left icon-p24-arrow2-left"></div>'),
  );
  $(element).prepend(
    $('<div class="scroll-button scroll-right icon-p24-arrow2-right"></div>'),
  );

  $(element)
    .find("stage")
    .each(function (index, stage) {
      const range = document.createRange();
      range.selectNodeContents(stage);
      const stageInner = document.createElement("div");
      stageInner.classList.add("stage-inner");
      const stagePointer = document.createElement("div");
      stagePointer.classList.add("stage-pointer");
      range.surroundContents(stageInner);
      const stageSelector = $(stage);
      stageSelector.append($(stagePointer));
      stageSelector.attr("data-column", 1);
      stageSelector.attr("data-row", 1);
      stageSelector.addClass("m");
      const stageColor = stageSelector.attr("color");
      if (stageColor) {
        if (stageSelector.filter("[active=true]").length) {
          stageSelector.css("border-color", stageColor);
        } else {
          stageSelector.find(".stage-inner").css("border-color", stageColor);
        }
      }
      stageSelector.parentsUntil("process").each(function (_, parent) {
        const parentSelector = $(parent);
        if (parentSelector.children().not(".m").length === 0) {
          let col = 0;
          let row = 0;
          if (parentSelector.is("stages")) {
            parentSelector.children().each(function () {
              col += parseInt($(this).attr("data-column") ?? "");
              row = Math.max(row, parseInt($(this).attr("data-row") ?? ""));
            });
          } else if (parentSelector.is("multistage")) {
            parentSelector.children().each(function () {
              col = Math.max(col, parseInt($(this).attr("data-column") ?? ""));
              row += parseInt($(this).attr("data-row") ?? "");
            });
          }
          parentSelector.attr("data-column", col);
          parentSelector.attr("data-row", row);
          parentSelector.addClass("m");
        }
      });
    });
  $(element)
    .find("stages.m, multistage.m")
    .each(function (_, el) {
      let col = 1;
      let row = 1;
      $(el)
        .children()
        .each(function () {
          let colEnd:any;
          if ($(this).is("stage")) {
            $(this).css("grid-row", "1 / 2");
            colEnd = col + parseInt($(this).attr("data-column") ?? "");
            $(this).css("grid-column", col + " / " + colEnd);
            col = colEnd;
          } else if ($(this).is("stages")) {
            colEnd = parseInt($(this).attr("data-column") ?? "");
            $(this)
              .siblings()
              .each(function () {
                colEnd = Math.max(
                  colEnd,
                  parseInt($(this).attr("data-column") ?? ""),
                );
              });
            colEnd += 1;
            const rowEnd = row + parseInt($(this).attr("data-row") ?? "");
            $(this).css("grid-row", row + " / " + rowEnd);
            $(this).css("grid-column", "1 / " + colEnd);
            row = rowEnd;
          } else if ($(this).is("multistage")) {
            $(this).css(
              "grid-row",
              1 + " / " + (parseInt($(this).attr("data-row") ?? "") + 1),
            );
            colEnd = col + parseInt($(this).attr("data-column") ?? "");
            $(this).css("grid-column", col + " / " + colEnd);
            col = colEnd;
          }
        });
    });
  const numberOfActiveElements = $(element).find("stage[active=true]").length;
  if (
    numberOfActiveElements === 1 &&
    $(element).filter("[disableMarkActivePath=true]").length === 0
  ) {
    const activeElement = $(element).find("stage[active=true]");
    const color =
      activeElement.attr("color") ||
      getComputedStyle(element).getPropertyValue(
        "--stage-active-default-border-color",
      );
    activeElement.addClass("active-path");
    activeElement.prevAll("stage").addClass("active-path");
    // tu jeszcze do lekkiej poprawki na end
    activeElement
      .prevAll("multistage")
      .addClass("active-path")
      .find("stage")
      .addClass("active-path");
    activeElement
      .parentsUntil("process", "multistage")
      .each(function (_, multistage) {
        $(multistage)
          .addClass("active-path")
          .prevAll("stage")
          .addClass("active-path");
        $(multistage).prev("stage").addClass("active-path-left");
        $(multistage)
          .prevAll("multistage")
          .find("stage")
          .addClass("active-path");
      });
    element.style.setProperty("--stage-active-border-color", color);
  } else if (numberOfActiveElements > 1) {
    $(element).addClass("multi");
  }
  const checkScrollButtonsVisibility = function (processSelector:any) {
    const overflowing =
      processSelector.scrollWidth > processSelector.clientWidth;
    const scrollLeftMax =
      processSelector.scrollLeftMax ||
      processSelector.scrollWidth - processSelector.clientWidth;
    if (overflowing && processSelector.scrollLeft > 0) {
      $(processSelector).find(">.scroll-left").show();
    } else {
      $(processSelector).find(">.scroll-left").hide();
    }
    if (overflowing && processSelector.scrollLeft < scrollLeftMax) {
      $(processSelector).find(">.scroll-right").show();
    } else {
      $(processSelector).find(">.scroll-right").hide();
    }
  };

  if ($(element).find("stage[active=true]").first().length === 1) {
    $(element).animate(
      {
        scrollLeft:
          ($(element).find("stage[active=true]").first().get(0)?.offsetLeft ??
            0) +
          DEFAULT_STAGE_SCROLL_OFFSET -
          element.offsetWidth / 2,
      },
      {
        queue: false,
        duration: 50,
        complete: function () {
          checkScrollButtonsVisibility(element);
        },
      },
    );
  }
  const observer = new ResizeObserver(function (e) {
    checkScrollButtonsVisibility(e[0].target);
  });

  observer.observe(element);
  $(element)
    .find(".scroll-button")
    .on("click", function (e) {
      const direction = $(e.currentTarget).hasClass("scroll-right") ? 1 : -1;
      const position = element.scrollLeft + direction * DEFAULT_SCROLL_PAGE_SIZE;
      $(element).animate(
        {
          scrollLeft: position,
        },
        {
          queue: false,
          duration: 50,
          complete: function () {
            checkScrollButtonsVisibility(element);
          },
        },
      );
    });
}

export class ProcessTransform extends EldmlTransform {
  apply() {
    this.selector.find("process").each((_, element) => {
      transformProcessElement(element);
    });
  }
}
